import React from "react";

import PageHero from "../../components/common/PageHero";
import PageSectionHeader from "../../components/common/PageSectionHeader";
import useScrollToTop from "../../hooks/useScollToTop";
import ScrollIndicator from "../Home/ScrollIndicator";

import NewsFilters from "./components/NewsFilters";
import NewsList from "./components/NewsList";
import Pagination from "./components/Pagination";
import NewsDetailModal from "./components/NewsDetailModal";

import { NEWS_PAGE } from "./data/newsUiData";
import { useNewsPage } from "./hooks/useNewsPage";

export default function NewsPage() {
  useScrollToTop();

  const {
    loading,
    error,
    items,
    paginatedItems,
    total,
    allTotal,
    totalPages,
    years,
    filters,
    page,
    selectedNews,
    updateFilter,
    resetFilters,
    toggleYear,
    setLimit,
    setSort,
    setDir,
    goToPrevPage,
    goToNextPage,
    refresh,
    openNews,
    closeNews,
  } = useNewsPage();

  return (
    <>
      <PageHero
        title="Actualités"
        imageUrl={NEWS_PAGE.heroImageUrl}
        crumbs={NEWS_PAGE.crumbs}
      />

      <ScrollIndicator />

      <main className="mx-auto max-w-[1240px] px-4 pb-16 pt-6 sm:px-6 md:pt-8">
        <PageSectionHeader
          eyebrow={NEWS_PAGE.eyebrow}
          title={NEWS_PAGE.title}
          description={NEWS_PAGE.description}
        >
          <div className="rounded-3xl border border-slate-200 bg-white/80 px-5 py-4 shadow-sm backdrop-blur dark:border-slate-800 dark:bg-slate-950/70">
            <p className="text-xs font-bold uppercase tracking-[0.18em] text-slate-500 dark:text-slate-400">
              Actualités publiées
            </p>
            <p className="mt-1 text-3xl font-bold text-slate-950 dark:text-white">
              {loading ? "…" : allTotal}
            </p>
            <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
              visible{allTotal > 1 ? "s" : ""}
            </p>
          </div>
        </PageSectionHeader>

        <div className="mt-5">
          <NewsFilters
            loading={loading}
            filters={filters}
            years={years}
            total={total}
            allTotal={allTotal}
            onChange={updateFilter}
            onYearClick={toggleYear}
            onReset={resetFilters}
            onRefresh={refresh}
            onLimit={setLimit}
            onSort={setSort}
            onDir={setDir}
          />
        </div>

        {error && (
          <div className="mt-5 rounded-3xl border border-red-200 bg-red-50 px-5 py-4 text-sm font-semibold text-red-700 dark:border-red-900/60 dark:bg-red-950/30 dark:text-red-300">
            Une erreur est survenue pendant le chargement des actualités.
          </div>
        )}

        <section className="mt-6">
          <NewsList
            items={paginatedItems}
            loading={loading}
            onOpen={openNews}
          />

          {!loading && items.length > 0 && (
            <Pagination
              page={page}
              totalPages={totalPages}
              total={total}
              limit={filters.limit}
              onPrev={goToPrevPage}
              onNext={goToNextPage}
              disabled={loading}
            />
          )}
        </section>
      </main>

      {selectedNews && (
        <NewsDetailModal item={selectedNews} onClose={closeNews} />
      )}
    </>
  );
}